import { CoverageNeed } from "Store/akaAdvice/interfaces/CollectiveAdvice";

import { Description } from "Features/CheckPrice/Products/Advice/adviceStyled";
import { InsuranceCoverage } from "Store/advice/interfaces";
import { isDefined } from "Utils/functions";
import React from "react";

interface Props {
  need: CoverageNeed;
  adviceTexts: any;
  lang: string;
}

export const AkaCriticalIllnessAdviceText = ({
  need,
  adviceTexts,
  lang,
}: Props): React.ReactElement | null => {
  const recommendedCoverage = need.recommendedCoverage;

  if (!isDefined(recommendedCoverage)) {
    return null;
  }

  const { desc } = adviceTexts;

  let coversIncome;
  if (recommendedCoverage === InsuranceCoverage.TOP) {
    coversIncome = "Dette tilsvarer en årslønn";
  } else if (recommendedCoverage === InsuranceCoverage.PLUS) {
    coversIncome = "Dette tilsvarer en halv årslønn";
  } else {
    coversIncome = "";
  }

  const becauseOf = desc.part3[lang];

  let yourEconomicalSituation = "";
  if (recommendedCoverage === InsuranceCoverage.BASIC) {
    yourEconomicalSituation = desc.part4.basic[lang];
  } else if (recommendedCoverage === InsuranceCoverage.PLUS) {
    yourEconomicalSituation = desc.part4.plus[lang];
  } else if (recommendedCoverage === InsuranceCoverage.TOP) {
    yourEconomicalSituation = desc.part4.top[lang];
  }

  return (
    <Description fw={400} size="14px" className="AdviceTextsReason">
      {`${coversIncome}${becauseOf}${yourEconomicalSituation}`}
    </Description>
  );
};
